const UrlForm = (props) => {
  return (
    <div>
      {!props.sessionData && (
        <div className="invite-help-text">
          Generate a session link and a code by clicking the below button.
        </div>
      )}
      {props.sessionData && (
        <div className="invite-url-result">
          <div>
            <span className="lbl">Session guest link:</span>
            <a
              href={props.sessionData.guestURL}
              target="_blank"
              rel="noopener noreferrer"
            >
              {props.sessionData.guestURL}
            </a>
          </div>
          <div>
            <span className="lbl">Session code:</span>
            {props.sessionData.sessionID}
          </div>
        </div>
      )}
    </div>
  );
};

export default UrlForm;
